import React from 'react'

import numeral from 'numeral'

import {
  Notice,
  Icon as TriangleIcon,
  AttentionFilled,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  shape, string, bool, number,
} from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'

function RecipientDetails({ recipient }) {
  const { attributes } = recipient || {}
  const { isAdmin, username } = attributes || {}

  return (
    <div className="recipient-details-section">
      {!isAdmin && !!username && (
        <div className="cgt-mb-10">
          <Notice
            type="attention"
            borderSize="thin"
            useSSRIcon
            ssrIcon={<TriangleIcon svgComponent={AttentionFilled} color="attention" />}
          >
            <p className="cgt-legacy-text-caption cgt-mb-0">
              This individual is not an employee of CGTrader.
            </p>
          </Notice>
        </div>
      )}
      <div className="section__item recipient-details-section__header">
        <span className="author author--small">
          <a href={recipient.attributes.profileUrl} className="author__avatar">
            <UserAvatar
              className="u-mr10"
              size={isAdmin ? '' : 'small'}
              img={recipient.attributes.avatar.url}
              userName={username}
            />
          </a>
          <div className="u-inline-block author__attributes">
            <a href={recipient.attributes.profileUrl}>
              <span>{username}</span>
            </a>
            {isAdmin && (
              <div>
                <small>
                  Admin
                  <Icon type={['fas', 'shield-check']} color="grey-dark" className="ml-5" />
                </small>
              </div>
            )}
          </div>
        </span>
      </div>
      <div className="section__item">
        <span>
          Response rate:
          <b className="u-ml10 u-float-right">{numeral(recipient.attributes.responseRate).format('0%')}</b>
        </span>
      </div>
      <div className="section__item">
        <span>
          Response time:
          <b className="u-ml10 u-float-right">{numeral(recipient.attributes.responseTime).format('0.0')}h</b>
        </span>
      </div>
      <div className="section__item">
        <span>
          3D Projects completed:
          <b className="u-ml10 u-float-right">{recipient.attributes.jobsCompleted}</b>
        </span>
      </div>
      <div className="section__item">
        <span>
          3D models:
          <b className="u-ml10 u-float-right">{recipient.attributes.itemsCount}</b>
        </span>
      </div>
      {recipient.attributes.itemsCount > 0 && recipient.attributes.allowPrivateJobRequests
        ? (
          <div className="section__item u-text-center">
            <a
              className="button"
              href={`/3d-modeling-jobs/new/hire-designer/${username}?meta_source=conversation`}
            >
              <Icon type="dollar-sign" />
              Hire me
            </a>
          </div>
        )
        : null}
    </div>
  )
}

RecipientDetails.propTypes = {
  recipient: shape({
    id: string.isRequired,
    attributes: shape({
      username: string.isRequired,
      profileUrl: string.isRequired,
      responseRate: number.isRequired,
      responseTime: number.isRequired,
      jobsCompleted: number.isRequired,
      itemsCount: number.isRequired,
      allowPrivateJobRequests: bool.isRequired,
      avatar: shape({
        url: string,
      }).isRequired,
    }).isRequired,
  }).isRequired,
}

export default RecipientDetails
